@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.Sequence {
  padding-left: 10px; // create a gutter, half the icon circle width

  .SequenceInner {
    position: relative;
    padding-left: 16px;
    padding-bottom: 3em;
    border-left: 2px solid $color-primary-purple;

    .Label {
      @extend %font-family-primary;

      font-weight: $font-weight-bold;
      color: $color-primary-purple;
      font-size: $font-size-normal;
    }

    .IconWrapper {
      font-size: 0;
      left: -1px;
      transform: translateX(-50%);
      position: absolute;
      background: $color-primary-purple;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      display: grid;
      align-items: center;
      justify-items: center;

      svg {
        width: 12px;
        height: 12px;
      }

      path {
        fill: $color-white;
      }
    }

    .ChildrenWrapper {
      border-bottom: 2px solid $theme-color-borders;

      &:last-child {
        border-bottom: 0;
      }
    }

    &::after {
      content: '\0025BC'; // http://www.fileformat.info/info/unicode/char/25BC/index.htm
      font-size: $font-size-normal;
      top: 50%;
      color: $color-primary-purple;
      position: absolute;
      transform: translateX(-50%);
      line-height: 0;
      left: -1px;
    }

    &:last-child {
      border-color: transparent; // the border must still exist for consistent child sizing

      &::after {
        content: none;
      }
    }
  }
}
